import { ApplicationConfig, DEFAULT_CURRENCY_CODE, LOCALE_ID, provideBrowserGlobalErrorListeners } from '@angular/core'
import { provideHttpClient, withFetch } from '@angular/common/http'
import { provideRouter, TitleStrategy, withComponentInputBinding, withHashLocation } from '@angular/router'

import { routes } from './app.routes'
import { DATE_PIPE_DEFAULT_OPTIONS } from '@angular/common'
import { AppTitleStrategy } from './core/app-title-strategy'

export const appConfig: ApplicationConfig = {
    providers: [
        { provide: LOCALE_ID, useValue: 'en-GB' },
        {
            provide: DEFAULT_CURRENCY_CODE,
            useValue: 'GBP',
        },
        {
            provide: DATE_PIPE_DEFAULT_OPTIONS,
            useValue: { dateformat: 'dd/MM/yyyy' },
        },
        {
            provide: TitleStrategy,
            useClass: AppTitleStrategy,
        },
        provideBrowserGlobalErrorListeners(),
        provideRouter(routes, withHashLocation(), withComponentInputBinding()),
        provideHttpClient(withFetch()),
    ],
}
